// extracted by mini-css-extract-plugin
module.exports = {"subrow":"feed-activity-content_subrow_oJtr5"};